import type { RealtimeConnectionState } from './connectionStateTracker';

export type RealtimeStatusMessage =
  | { kind: 'hidden' }
  | { kind: 'offline' }
  | { kind: 'connecting' }
  | { kind: 'disconnected'; disconnectedSince: Date };

const HIDDEN: RealtimeStatusMessage = { kind: 'hidden' };
const OFFLINE: RealtimeStatusMessage = { kind: 'offline' };
const CONNECTING: RealtimeStatusMessage = { kind: 'connecting' };

export function selectRealtimeStatusMessage(
  connection: RealtimeConnectionState,
  isOnline: boolean,
): RealtimeStatusMessage {
  if (!isOnline) {
    return OFFLINE;
  }

  switch (connection.status) {
    case 'connected':
      return HIDDEN;
    case 'never-connected':
      return CONNECTING;
    case 'disconnected':
      return { kind: 'disconnected', disconnectedSince: connection.disconnectedSince };
  }
}
